import * as angular from 'angular';
import { ChannelsService } from '../channels/ChannelsService';
import HomeView from './HomeView.html';
import { HomeController } from './HomeController';
import { CoolStuffComponent } from './CoolStuff/coolStuff.component';
import { FirstStepDashboardComponent } from './FirstStepsBotComponent/firstStepsDashboard.component';
import { OnboardingChecklistComponent } from './OnboardingChecklist/OnboardingChecklist.component';
import { OnboardingChecklistStepComponent } from './OnboardingChecklist/OnboardingChecklistStep/OnboardingChecklistStep.component';
import { ApplicationService2 } from 'modules/application/ApplicationService2';
import { AnalyticsReportsService } from '../analytics/services/AnalyticsReportsService';
import { AiAgentService } from 'modules/application/misc/AiAgentService';
import { DefaultOnboardingChecklistComponent } from './DefaultOnboardingChecklist/DefaultOnboardingChecklist.component';
import { MarketplaceOnboardingComponent } from './MarketplaceOnboarding/MarketplaceOnboarding.component';
export const homeName = 'auth.application.detail.home';
export const home = angular
    .module('application.home', ['ui.router'])
    .service('ChannelsService', ChannelsService)
    .service('applicationService2', ApplicationService2)
    .service('AnalyticsReportsService', AnalyticsReportsService)
    .component('coolStuff', CoolStuffComponent)
    .component('firstStepsDashboard', FirstStepDashboardComponent)
    .component('defaultOnboardingChecklist', DefaultOnboardingChecklistComponent)
    .component('onboardingChecklist', OnboardingChecklistComponent)
    .component('onboardingChecklistStep', OnboardingChecklistStepComponent)
    .component('marketplaceOnboarding', MarketplaceOnboardingComponent)
    .controller('HomeController', HomeController)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state(homeName, {
            url: '/home?appcue',
            views: {
                'content@auth.application.detail': {
                    template: HomeView,
                    controller: HomeController,
                    controllerAs: '$ctrl',
                },
            },
            resolve: {
                checkLayout: AiAgentService.blockAiAgentAccess,
            },
        });
    }]).name;
